/**
 * ProLayout `menuContentRender`：在 BaseMenu 外包一层滚动容器（`.video-ui-sider-menu-inner`），
 * 便于样式作用域与 `global.less` 里对侧栏菜单的覆盖。
 */
import type { SiderMenuProps } from '@ant-design/pro-layout/es/components/SiderMenu/SiderMenu';
import React from 'react';

type MenuContentProps = SiderMenuProps;

/** 包裹菜单区域，便于与顶栏统一响应 `.ant-pro-sider:hover` 显示收起按钮 */
export function siderMenuContentRender(
  props: MenuContentProps,
  defaultDom: React.ReactNode,
): React.ReactNode {
  return (
    <div className="video-ui-sider-menu-inner" data-sider-menu-scroll>
      {defaultDom}
    </div>
  );
}
